/* eslint-disable camelcase */
import Location from 'services/Location';
import { getAccessToken, organizationIDEscaped } from 'helpers/account';
import { saveItem } from 'helpers/storage/session-storage';
import { parseJwt } from 'helpers/token';
import { buildOauthQuery } from './oath-query-builder';

export const navigateToSelectedProduct = (email: string, organizationId?: string): void => {
  saveItem('signup', '1');
  const state = Location.getHashParam('state') || Location.getUrlParam('state');
  const jwt = parseJwt(state);
  const {
    client_id,
    organization_id,
    redirect_uri,
    response_type,
    flow,
    state: originalState,
    code_challenge,
    code_challenge_method,
    entrypoint,
  } = jwt;

  if (entrypoint) {
    window.location.href = `${entrypoint}/?organization_id=${organizationIDEscaped(organizationId || organization_id)}&email=${encodeURIComponent(email)}`;
  } else {
    const redirectParam = {
      client_id,
      redirect_uri,
      response_type,
      ...(flow ? { flow } : {}),
      state: originalState,
      code_challenge,
      code_challenge_method,
    };
    window.location.href = `/?organization_id=${organizationIDEscaped(organizationId || organization_id)}&${buildOauthQuery(
      redirectParam
    )}&email=${encodeURIComponent(email)}`;
  }
};

export const navigateToOriginalUrl = (): void => {
  const accessToken = getAccessToken();
  const request = Location.getUrlParam('request');
  const clientID = Location.getUrlParam('client_id');

  // if everything is ok, redirect to the original url with jar params
  // the token carries session transfer, we can enstablish a new session if needed
  if (accessToken && request && clientID) {
    saveItem('signup', '1');
    const params = new URLSearchParams();
    params.set('access_token', accessToken);
    params.set('request', request);
    params.set('client_id', clientID);
    params.set('signup', '1');
    window.location.href = `/?${params.toString()}`;
    return;
  }

  window.location.href = '/';
};

export const isStateJwtToken = (state: string | undefined): boolean =>
  state?.split('.').length === 3;
